import { render, staticRenderFns } from "./CadPin.vue?vue&type=template&id=8b86c1cc"
import script from "./CadPin.vue?vue&type=script&lang=js"
export * from "./CadPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports